module.exports = __webpack_public_path__ + "static/media/category-icon-white.5f1f1502.svg";